import { loadGenerateExtras } from '@/lib/thesisGenerateExtras'
import { canDraftChapter } from './chapterAccess'
import { buildThesisSystemPrompt } from './injectContext'
import { useThesisBriefStore } from '@/stores/thesisBriefStore'
import { useThesisWorkspaceStore } from '@/stores/thesisWorkspaceStore'

function novelIdFromPath(): string | undefined {
  return window.location.pathname.match(/\/(?:papers|novels)\/([^/]+)/)?.[1]
}

/** 生成节点调用：从当前 URL + store 拼完整 system（Brief+契约+前章摘要） */
export function getLiveThesisSystemPrompt(): string {
  const novelId = novelIdFromPath()
  const extras = loadGenerateExtras()
  const chapterIndex = useThesisWorkspaceStore.getState().activeChapterIndex
  const brief = useThesisBriefStore.getState().ensureBrief(novelId || '_anon')
  return buildThesisSystemPrompt({
    brief,
    chapterIndex,
    action: extras.action,
    note: extras.note,
  })
}

export function assertLiveChapterAccess(): { ok: true } | { ok: false; message: string } {
  const novelId = novelIdFromPath()
  if (!novelId) return { ok: true }
  const brief = useThesisBriefStore.getState().ensureBrief(novelId)
  const chapterIndex = useThesisWorkspaceStore.getState().activeChapterIndex
  if (chapterIndex == null) return { ok: true }
  const access = canDraftChapter(brief, chapterIndex)
  if (access.ok) return { ok: true }
  return { ok: false, message: access.message }
}
